import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=66b8d6b2&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"
import style0 from "./monitor.vue?vue&type=style&index=0&id=66b8d6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b8d6b2",
  null
  
)

export default component.exports